export const ModalType = {
    Create: 0,
    Edit: 1,
    View: 2,
};
